import React from 'react'
// import styled from "styled-components"

export const Loading: React.FC<{}> = () => {
  return <React.Fragment>Loading...</React.Fragment>
}
